export default function AppSection() {
  return (
    <section id="app" className="section-scroll py-14 md:py-20 bg-gradient-to-br from-gray-950 via-gray-900 to-red-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="text-red-400 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">随时随地观影</p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">移动观影</h2>
            <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              91年国产影片视频全面适配移动端，无需下载APP即可在手机上畅享91在线观看免费体验。打开浏览器输入网址，高清视频即刻播放，支持91在线免费播放、投屏观看等多种方式，让你随时随地享受91免费看视频的乐趣。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 border border-white/10">
                <i className="ri-smartphone-line text-red-400 text-lg"></i>
                <span className="text-white text-sm font-medium whitespace-nowrap">手机即开即播</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 border border-white/10">
                <i className="ri-tv-line text-red-400 text-lg"></i>
                <span className="text-white text-sm font-medium whitespace-nowrap">支持投屏观看</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 border border-white/10">
                <i className="ri-wifi-line text-red-400 text-lg"></i>
                <span className="text-white text-sm font-medium whitespace-nowrap">省流模式可选</span>
              </div>
            </div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-red-600 hover:bg-red-500 text-white font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200 hover:scale-105"
            >
              <i className="ri-play-circle-line"></i>立即体验移动观影
            </a>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-red-600/20 to-amber-500/20 rounded-3xl blur-xl"></div>
              <div className="relative w-56 md:w-64 rounded-3xl overflow-hidden border-2 border-white/20 shadow-2xl bg-gray-900">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%20layout%2C%20dark%20theme%20with%20warm%20red%20and%20amber%20accent%20colors%2C%20video%20thumbnails%20with%20play%20buttons%2C%20clean%20minimal%20UI%20design%2C%20cinematic%20aesthetic%2C%20phone%20floating%20in%20darkness%20with%20soft%20glow%2C%20professional%20product%20photography&width=500&height=900&seq=mobile-app-preview&orientation=portrait"
                  alt="91年国产影片视频 - 移动端观影体验"
                  className="w-full h-auto object-cover"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    const p = t.parentElement;
                    if (p) {
                      p.classList.add('flex', 'items-center', 'justify-center');
                      p.innerHTML = '<div class="text-gray-500 text-sm py-20">移动观影界面</div>';
                    }
                  }}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                  <p className="text-white text-xs text-center font-medium">手机浏览器直接访问</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}